module.exports = __webpack_public_path__ + "static/img/pic_shipyasuo_132＊132@2x.85af3b97.png";